import React, { Component } from "react";

import { Icon, Header, Table } from "semantic-ui-react";

import * as moment from "moment";

import { connect } from "react-redux";

import { requestOpenReimbursementModal } from "../actions/reimbursements";

class ReimbursementRow extends Component {
  click = () => {
    if (!this.props.noModal) {
      this.props.requestOpenModal(this.props.reimbursement.uuid);
    }
    if (this.props.clickAction) {
      this.props.clickAction(this.props.reimbursement);
    }
  };

  renderStatus = () => {
    const reimbursement = this.props.reimbursement;
    if (reimbursement.status === "received") {
      return (
        <span>
          <Icon name="question mark" /> Unsubmitted
        </span>
      );
    } else if (reimbursement.status === "submitted") {
      return (
        <span>
          <Icon name="right arrow" /> Waiting approval
        </span>
      );
    } else if (reimbursement.status === "approved") {
      return (
        <span>
          <Icon name="check" color="green" /> Approved
        </span>
      );
    } else if (reimbursement.status === "rejected") {
      return (
        <span>
          <Icon name="times" color="red" /> Rejected
        </span>
      );
    } else if (reimbursement.status === "paid") {
      return (
        <span>
          <Icon name="dollar sign" color="green" /> Paid{" "}
        </span>
      );
    }
  };

  render() {
    const reimbursement = this.props.reimbursement;
    const submitter = this.props.submitter || reimbursement.submitter;
    return (
      <Table.Row onClick={this.click}>
        <Table.Cell>
          <Header as="h5">
            <Header.Content>
              {reimbursement.description || "No description given"}
              <Header.Subheader>
                {reimbursement.amount ? (
                  <span>${(+reimbursement.amount).toFixed(2)}</span>
                ) : (
                  <span>No amount given.</span>
                )}
              </Header.Subheader>
            </Header.Content>
          </Header>
        </Table.Cell>
        {!this.props.noName && <Table.Cell>{submitter.name}</Table.Cell>}
        <Table.Cell>
          {moment(
            reimbursement.last_action_at || reimbursement.received_at
          ).format("llll")}
        </Table.Cell>
        <Table.Cell>{this.renderStatus()}</Table.Cell>
      </Table.Row>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  requestOpenModal: reimbursementUUID =>
    dispatch(requestOpenReimbursementModal(reimbursementUUID))
});

const ConnectedReimbursementRow = connect(
  null,
  mapDispatchToProps
)(ReimbursementRow);

const ReimbursementTable = props => {
  return (
    <Table
      selectable={
        (!props.noModal || !!props.clickAction) &&
        props.reimbursements.length > 0
      }
    >
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Reimbursement</Table.HeaderCell>
          {!props.noName && <Table.HeaderCell>{"For"}</Table.HeaderCell>}
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.reimbursements.map((reimbursement, i) => (
          <ConnectedReimbursementRow
            key={reimbursement.uuid}
            submitter={props.submitter}
            reimbursement={reimbursement}
            noModal={props.noModal}
            noName={props.noName}
            clickAction={props.clickAction}
          />
        ))}
        {props.reimbursements.length === 0 && (
          <Table.Row>
            <Table.Cell colSpan={props.noName ? "3" : "4"}>
              {props.emptyText || "There are no reimbursements to show."}
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default ReimbursementTable;



// WEBPACK FOOTER //
// ./frontend/src/components/ReimbursementTable.js